<template>
  <div class="FMFilePreview w-100 h-100 align-items-stretch flex" style="min-height: 0; flex: 1">
    <template
      v-if="
        file.fileUUID != null &&
        (file.mimeType.startsWith('text/') || file.mimeType === 'application/json')
      "
    >
      <FMFileViewerText
        :overflow-hidden="overflowHidden"
        :file-u-u-i-d="file.fileUUID"
        :mime-type="file.mimeType"
        :recently-changed="recentlyChanged"
        :big-shadow="bigShadow"
      />
    </template>
    <template v-else-if="file.fileUUID != null && file.mimeType.startsWith('image/')">
      <FMFileViewerImage
        :file-u-u-i-d="file.fileUUID"
        :recently-changed="recentlyChanged"
        :big-shadow="bigShadow"
      />
    </template>
    <template v-else-if="file.fileUUID != null && file.mimeType.startsWith('video/')">
      <FMFileViewerVideo
        :autoplay="true"
        :controls="showControls ?? !onlyView"
        :recently-changed="recentlyChanged"
        :file-u-u-i-d="file.fileUUID"
        :big-shadow="bigShadow"
      />
    </template>
    <template v-else-if="file.fileUUID != null && file.mimeType === 'application/pdf'">
      <!-- 
        When overflowHidden is true and onlyView is true, 
        we show the slider version of the PDF viewer,
        which only shows the first page and fits it perfectly into viewport 
      -->
      <FMFileViewerSliderPDF
        v-if="overflowHidden && onlyView"
        :file-u-u-i-d="file.fileUUID!"
        :visible-time-in-seconds="1"
        :custom-pages-order="[1]"
        :recently-changed="recentlyChanged"
        :big-shadow="bigShadow"
      />
      <FMFileViewerPDF
        v-else
        :overflow-hidden="overflowHidden"
        :hide-toolbar="onlyView"
        :file-u-u-i-d="file.fileUUID"
        :recently-changed="recentlyChanged"
        :big-shadow="bigShadow"
      />
    </template>
    <template v-else-if="file.fileUUID != null && file.mimeType.startsWith('audio/')">
      <FMFileViewerAudio
        :file-u-u-i-d="file.fileUUID"
        :autoplay="true"
        :controls="showControls ?? !onlyView"
        :recently-changed="recentlyChanged"
      />
    </template>
    <template v-else>
      <div class="flex flex-column justify-content-between align-items-center gap-2 w-100 h-100">
        <i class="fas fa-file-circle-question" style="font-size: 5em; opacity: 50%" />
        {{ file.name }}
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import FMFileViewerPDF from "./FMFileViewer/pdf/FMFileViewerPDF.vue";
import FMFileViewerImage from "./FMFileViewer/FMFileViewerImage.vue";
import FMFileViewerText from "./FMFileViewer/FMFileViewerText.vue";
import FMFileViewerVideo from "./FMFileViewer/FMFileViewerVideo.vue";
import FMFileViewerAudio from "./FMFileViewer/FMFileViewerAudio.vue";
import FMFileViewerSliderPDF from "./FMFileViewer/pdf/FMFileViewerSliderPDF.vue";

defineProps({
  file: {
    type: Object as PropType<{
      fileUUID?: string;
      name: string;
      mimeType: string;
    }>,
    required: true,
  },
  overflowHidden: {
    type: Boolean,
    required: false,
    default: false,
  },
  onlyView: {
    type: Boolean,
    required: false,
    default: false,
  },
  showControls: {
    type: Boolean,
    required: false,
    default: undefined,
  },
  recentlyChanged: {
    type: Boolean,
    required: false,
    default: false,
  },
  bigShadow: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>
<style lang="scss" scoped></style>
